import type { AppProps } from 'next/app';
import Head from 'next/head';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import Footer from '@/components/layout/Footer';
import Header from '@/components/layout/Header';
import Providers from '@/components/misc/Providers';

import '../styles/globals.css';

const App = ({ router, Component, pageProps }: AppProps) => {
  NProgress.configure({
    showSpinner: false,
  });

  return (
    <Providers>
      <style jsx global>{`
        html,
        body,
        #__next {
          height: 100%;
        }

        #nprogress .bar {
          background: #d41121 !important;
        }

        #nprogress .peg {
          box-shadow:
            0 0 10px #d41121,
            0 0 5px #d41121;
        }
      `}</style>

      {router.route === '/gesamtstatistik' ? (
        <Component {...pageProps} />
      ) : (
        <div className="flex h-full flex-col antialiased">
          <Header />
          <main className="flex-1 px-4 py-12">
            <Head>
              <link rel="icon" href="/emblem.svg" />
            </Head>

            <Component {...pageProps} />
          </main>
          <Footer />
        </div>
      )}
    </Providers>
  );
};

export default App;
